import {
    GET_UPLOAD_DOCS_LOADING,
    GET_UPLOAD_DOCS_SUCCESS,
    GET_UPLOAD_DOCS_FAILURE,
    GET_UPLOAD_DOCS_RESET,
    GET_EVENT_PHOTOS_LOADING,
    GET_EVENT_PHOTOS_SUCCESS,
    GET_EVENT_PHOTOS_FAILURE,
    GET_EVENT_PHOTOS_RESET
} from '../../actions/types';

const INITIAL_STATE = {
    docs: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    },
    photos: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    },
};

const uploadFileReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_UPLOAD_DOCS_LOADING:
            return {
                ...state,
                docs: {
                    ...state.docs,
                    get: {
                        ...state.docs.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.docs.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_UPLOAD_DOCS_SUCCESS:
            return {
                ...state,
                docs: {
                    ...state.docs,
                    get: {
                        ...state.docs.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.docs.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_UPLOAD_DOCS_FAILURE:
            return {
                ...state,
                docs: {
                    ...state.docs,
                    get: {
                        ...state.docs.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.docs.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
        case GET_UPLOAD_DOCS_RESET:
            return {
                ...state,
                docs: {
                    ...state.docs.get,
                    post: {
                        ...INITIAL_STATE.docs.get,
                        reset: true,
                    },
                },
            }
        case GET_EVENT_PHOTOS_LOADING:
            return {
                ...state,
                photos: {
                    ...state.photos,
                    get: {
                        ...state.photos.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.photos.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_EVENT_PHOTOS_SUCCESS:
            return {
                ...state,
                photos: {
                    ...state.photos,
                    get: {
                        ...state.photos.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.photos.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_EVENT_PHOTOS_FAILURE:
            return {
                ...state,
                photos: {
                    ...state.photos,
                    get: {
                        ...state.photos.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.photos.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
        case GET_EVENT_PHOTOS_RESET:
            return {
                ...state,
                photos: {
                    ...state.photos.get,
                    post: {
                        ...INITIAL_STATE.photos.get,
                        reset: true,
                    },
                },
            }
    }
    return state;
}

export default uploadFileReducers;